import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalDataService } from '../../../services/global-data.service';

@Injectable()
export class CurrencyService {

  constructor(
              private http: HttpClient, 
              private global: GlobalDataService
             ) { }


   getCurrency() {
        return this.http.get(this.global.httpUrl+"currencies");
    }

   getCurrencyById(id: any) {
        return this.http.get(this.global.httpUrl+"currencies/"+id);
    } 

   createCurrency(data: any){
        return this.http.post(this.global.httpUrl+"currencies", data);
    }

   updateCurrency(data: any,id: any){
        return this.http.put(this.global.httpUrl+"currencies/"+id, data);
    } 

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/currencies/currency.service.ts